/**
 * "Did the user click the card, or something inside it?"
 *
 * Cards that open something as a whole (the feed card, the degraded `new_post` alert, a `/watch`
 * row) all wrap links, buttons and tooltip triggers that own their own clicks, and all have text
 * worth selecting. One shared guard, so a new clickable card can never ship without it.
 */

import type { MouseEvent } from 'react';

export function isPlainCardClick(event: MouseEvent<HTMLElement>): boolean {
  if (!(event.target instanceof Element)) return false;
  // Links, buttons, media controls and tooltip triggers own their own clicks.
  if (event.target.closest('a, button, input, .tip') !== null) return false;
  // Never hijack the end of a text selection.
  return (window.getSelection()?.toString().length ?? 0) === 0;
}
